export default __webpack_public_path__ + "9ffc77d32ff4d01e5f7fdcb9b48cc122.png";